// ============================================================
//  Rollenname, wie ihn ein SAP-Berechtigungsteam liest: zuerst der TECHNISCHE Name (Z_ASP_FI_VOLL_16),
//  daneben der Kurztext in gedämpfter Schrift — nur wenn er gepflegt ist. Nie ein erfundener Text.
// ============================================================
import type { ReactNode } from "react";

/** Kurztext aus dem Anzeigenamen; „" wenn nicht gepflegt oder gleich dem technischen Namen. */
export function roleShortText(id: string, name?: string): string {
  if (!name) return "";
  const t = name.trim();
  return t === "" || t === id ? "" : t;
}

export function RoleName({ id, name, mono = true, className = "", children }: { id: string; name?: string; mono?: boolean; className?: string; children?: ReactNode }) {
  const short = roleShortText(id, name);
  return (
    <span className={`inline-flex flex-wrap items-baseline gap-x-2 ${className}`}>
      <span className={`text-strong font-medium ${mono ? "font-mono" : ""}`}>{id}</span>
      {short && <span className="text-faint text-xs">{short}</span>}
      {children}
    </span>
  );
}
